import { LicensePrePaidSubFormWebComponent } from './component/LicensePrePaidSubFormWebComponent';
import { WEB_COMPONENT_LICENSE_PRE_PAID_SUBFORM } from '../../webcomponents.constants';

export { LicensePrePaidSubFormWebComponent };

window.customElements.define(WEB_COMPONENT_LICENSE_PRE_PAID_SUBFORM, LicensePrePaidSubFormWebComponent);
